import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { CanvasRoutingModule } from "./canvas-routing.module";
import { CanvasComponent } from "./containers/canvas/canvas.component";
import { StrokeWidthRandomPipe } from "../pipes/stroke-width-random.pipe";
import { SliderModule } from "primeng/slider";
import { SidebarModule } from "primeng/sidebar";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";
import { SpinnerModule } from "primeng/spinner";
import { ColorPickerModule } from "primeng/colorpicker";

@NgModule({
  imports: [
    CommonModule,
    CanvasRoutingModule,
    FormsModule,
    SliderModule,
    SidebarModule,
    ButtonModule,
    TooltipModule,
    SpinnerModule,
    ColorPickerModule
  ],
  declarations: [CanvasComponent, StrokeWidthRandomPipe],
  exports: [CanvasComponent, StrokeWidthRandomPipe]
})
export class CanvasModule {}
